import { ReconciliationStatus, StatusVariant, type VersionComparison } from '@consigli/types';
import { formatEnumToReadableText } from '@consigli/utils';
import { ColumnDef } from '@tanstack/react-table';

import { Badge } from '@/components';

const reconciliationStatusMapping: Record<
  ReconciliationStatus,
  { text: string; variant: StatusVariant }
> = {
  [ReconciliationStatus.ADDRESSED]: { text: 'Addressed', variant: StatusVariant.SUCCESS },
  [ReconciliationStatus.UNADDRESSED]: { text: 'Unaddressed', variant: StatusVariant.ERROR },
  [ReconciliationStatus.INDETERMINATE]: { text: 'Indeterminate', variant: StatusVariant.WARNING },
  [ReconciliationStatus.NA]: { text: 'N/A', variant: StatusVariant.INFO },
};

export const versionComparisonColumns: ColumnDef<VersionComparison>[] = [
  {
    header: 'Change Description',
    accessorKey: 'changeDescription',
    cell: ({ getValue }) => <span className="line-clamp-3">{(getValue() as string) || '—'}</span>,
  },
  {
    header: 'Version A',
    accessorKey: 'blobName',
    cell: ({ getValue }) => <span>{(getValue() as string | null) || '—'}</span>,
  },
  {
    header: 'Version B',
    accessorKey: 'refBlobName',
    cell: ({ getValue }) => <span>{(getValue() as string | null) || '—'}</span>,
  },
  {
    header: 'Match Confidence',
    accessorKey: 'matchConfidence',
    cell: ({ getValue }) => {
      const value = getValue() as number | null;
      return <span>{value != null ? `${value}%` : '—'}</span>;
    },
  },
  {
    header: 'Processor',
    accessorKey: 'processorName',
    cell: ({ getValue }) => <span>{formatEnumToReadableText(getValue() as string)}</span>,
  },
  {
    header: 'Reconciliation',
    accessorKey: 'reconciliationStatus',
    cell: ({ getValue }) => {
      const status = getValue() as ReconciliationStatus | null;
      if (!status) return <span>—</span>;
      const config = reconciliationStatusMapping[status];
      return <Badge text={config.text} variant={config.variant} />;
    },
  },
];
